import { CriticalityLevelEnum } from "@core/enums/criticality-level.enum";
import { NotificationSituationEnum } from "@core/enums/notification-situation.enum";
import { TypeContentNotificationsEnum, TypeNotificationsEnum } from "@core/enums/type-notifications.enum";

export class NotificacaoModel {

  id?: number;
  nivelCriticidade?: CriticalityLevelEnum;
  tipo?: TypeNotificationsEnum;
  tipoConteudo?: TypeContentNotificationsEnum;
  titulo?: string;
  textoPrincipal?: string;
  linkConteudo?: string;
  linkRedirecionamento?: string;
  situacao?: NotificationSituationEnum;
  dataCadastro?: any;
  usuarioCadastro?: string;
  dataAlteracao?: any;
  usuarioAlteracao?: string;
  ativo?: boolean;

  constructor(options: NotificacaoModel = {}) {
    this.id = options.id || null;
    this.nivelCriticidade = options.nivelCriticidade || null;
    this.tipo = options.tipo || null;
    this.tipoConteudo = options.tipoConteudo || null;
    this.titulo = options.titulo || null;
    this.textoPrincipal = options.textoPrincipal || null;
    this.linkConteudo = options.linkConteudo || null;
    this.linkRedirecionamento = options.linkRedirecionamento || null;
    this.situacao = options.situacao || null;
    this.dataCadastro = options.dataCadastro || null;
    this.usuarioCadastro = options.usuarioCadastro || null;
    this.dataAlteracao = options.dataAlteracao || null;
    this.usuarioAlteracao = options.usuarioAlteracao || null;
    this.ativo = options.ativo || null;
  }
}

